import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/components/page-main.vue';
import Page from '@/components/page-default.vue';
import NotFound from '@/components/page-404.vue';

const routes = [
	{ path: '/', name: 'home', component: Home },
	{ path: '/blog', name: 'blog', component: Page },
	{ path: '/blog/:slug', name: 'post', component: Page },
	{ path: '/:slug', name: 'page', component: Page },
	{ path: '/404', name: 'NotFound', component: NotFound },
	{ path: '/:pathMatch(.*)*', name: 'not-found-catch-all', component: NotFound },
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;
